<template>
    <div>
        <main class="main-content main-agenda-interna">
            <div class="container-fluid --orange">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <p class="agenda-title"><strong>AGENDA CULTURAL</strong></p>
                            <div class="datepicker-wrapper"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="header-cultural-agenda-internal" 
                :style="`background: url('${image_bg}')`">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="featured-image__infos" v-if="evento">
                                <p class="featured-image__date">{{date}}</p>
                                <p class="featured-image__title">{{evento.title}}</p>
                            </div>
                            <template v-else>
                                <content-loader 
                                    class="d-none d-lg-block d-md-block"
                                    style="margin: 40px auto; display:block"
                                    width="1100"
                                    height="344">

                                        <rect x="1" y="50" rx="0" ry="0" width="170" height="30" />
                                        <rect x="1" y="100" rx="0" ry="0" width="486" height="50" /> 
                                </content-loader>
                                <content-loader 
                                    class="d-md-none d-sm-block"
                                    style="margin: 40px auto; display:block"
                                    width="510"
                                    height="344">

                                        <rect x="1" y="1" rx="0" ry="0" width="170" height="30" />
                                        <rect x="1" y="50" rx="0" ry="0" width="486" height="50" /> 
                                </content-loader>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="col-12 title-agenda-interna"> 
                    <h1>Confira mais sobre o evento</h1>
                </div>
            </div>

            <div class="container">
                <div class="row container-agenda-interna">
                    <div class="col-10 col-lg-5 container-location">
                        <div class="container-info">
                            <template v-if="evento">
                                <h1>{{evento.location}}</h1>
                                <p>{{evento.address}}</p>
                                <p>{{evento.phone}}</p>
                                <div class="row container-date">
                                    <div class="date" v-for="date in dates" :key="date.getTime()">
                                        <span class="day">{{date.getDate()}}</span>
                                        <span class="month">
                                            {{utils.months[date.getMonth()]}}
                                        </span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <content-loader 
                                    class="d-none d-lg-block d-sm-block"
                                    style="margin: 40px auto; display:block"
                                    width="431"
                                    height="344">

                                        <rect x="1" y="1" rx="0" ry="0" width="230" height="30" />
                                        <rect x="1" y="60" rx="0" ry="0" width="400" height="30" />
                                        <rect x="1" y="120" rx="0" ry="0" width="150" height="30" />

                                        <rect x="1" y="170" rx="0" ry="0" width="65" height="65" />
                                        <rect x="90" y="170" rx="0" ry="0" width="65" height="65" />
                                        <rect x="180" y="170" rx="0" ry="0" width="65" height="65" />
                                </content-loader>
                                <content-loader 
                                    class="d-lg-none d-md-block"
                                    style="margin: 40px auto; display:block"
                                    width="573"
                                    height="344">

                                        <rect x="1" y="1" rx="0" ry="0" width="230" height="30" />
                                        <rect x="1" y="60" rx="0" ry="0" width="400" height="30" />
                                        <rect x="1" y="120" rx="0" ry="0" width="150" height="30" />

                                        <rect x="1" y="170" rx="0" ry="0" width="65" height="65" />
                                        <rect x="90" y="170" rx="0" ry="0" width="65" height="65" />
                                        <rect x="180" y="170" rx="0" ry="0" width="65" height="65" />
                                </content-loader>
                                
                            </template>
                        </div>

                        <div class="container-img">
                            <img 
                                v-if="evento && evento.image" 
                                :src="utils.image(evento.image,408,256)" 
                                alt="">
                        </div>
                        <div class="container-social">
                            <Share v-if="title" :title="title" />
                        </div>
                    </div>
                    <div class="col-10 col-lg-5 container-context container-context-schedule">
                        <h1>Informações</h1>
                        <span v-if="evento" v-html="evento.details" />
                        <template v-else>
                            <content-loader 
                                class=""
                                style="margin: 40px auto; display:block"
                                width="461"
                                height="344">

                                    <rect x="1" y="1" rx="0" ry="0" width="461" height="20" />
                                    <rect x="1" y="40" rx="0" ry="0" width="461" height="20" />
                                    <rect x="1" y="80" rx="0" ry="0" width="461" height="20" />
                                    <rect x="1" y="120" rx="0" ry="0" width="461" height="20" />
                                    <rect x="1" y="160" rx="0" ry="0" width="461" height="20" />

                            </content-loader>
                        </template>
                    </div>
                </div>

                <div class="row" v-if="evento">
                    <div class="col-12">
                        <ul class="content-tags">
                            <li v-for="tag in evento.tags" :key="tag">
                                <a href="#" @click.prevent="$root.$emit('gazetaweb:search',tag)">{{tag}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="row" v-if="evento && evento.related">
                    <div class="col-12">
                        <div class="container-title">
                            <p>Veja também</p>
                        </div>
                    </div>
                </div>

                <div class="row container-schedule">
                    <div class="col-12 col-lg-4" v-for="evento in related1" :key="evento.id">
                        <Related :event="evento" />
                    </div>
                    <div class="col-12 col-lg-4" v-for="evento in related2" :key="evento.id">
                        <Related :event="evento" />
                    </div>
                </div>
            </div>
        </main>

        <NotFound v-if="NOT_FOUND" />
        <Error v-if="ERROR" />
    </div>
</template>

<script>
import page from '@/api/page'
import utils from '@/utils'

import Related from '@/components/agenda/Related'
import Share from '@/components/agenda/Related'

import { ContentLoader } from 'vue-content-loader'

import NotFound from '@/views/NotFound'
import Error from '@/views/Error'

export default {
    name:'Detail',
    props:['content'],
    components:{Related, Share, NotFound, Error, ContentLoader},
    data() {
        return{
            title: '',
            evento: null,
            image_bg: '',
            date: null,
            dates: null,
            related1: null,
            related2: null,
            utils:utils,
            NOT_FOUND: false,
            ERROR: false,
        }
    },
    head:{
        title: function(){
            return {
                inner: this.title
            }
        }
    },
    watch: {
        evento: function() {
            if (this.evento.image_bg) {
                this.image_bg = utils.image(this.evento.image_bg, 1325, 316)
            }
            this.date = new Date(this.evento.start_date).toLocaleDateString('pt-BR', {
                dateStyle:'long'
            })
            this.dates = utils.dateRange(
                new Date(this.evento.start_date.replace(/-/g,'/')), 
                new Date(this.evento.end_date.replace(/-/g,'/'))
            )
            if (this.evento.related) {
                this.related1 = this.evento.related.slice(0,3)
                this.related2 = this.evento.related.slice(3,6)
            }
            this.title = this.evento.title
            this.$emit('updateHead')
        }
    },
    methods:{
        async getEvento() {
            if (!this.content) {

                const response = await page.get(`find/?html_path=${this.$route.path}`)
    
                if(response.ok) {
                    this.evento = response.data
                } else {
                    if (response.status === 404) {
                        this.NOT_FOUND = true
                    } else if (response.status >= 500) {
                        this.ERROR = true
                    }
                }
            } else {
                this.evento = this.content
            }
        }
    },
    mounted() {
        this.getEvento()
    }
}
</script>